












































































































import DeleteConfirmation from '../../../tracking/components/Geofences/DeleteConfirmation.vue';
import { Component, Emit, Mixins, Prop, Watch } from 'vue-property-decorator';
import { CompanyStoreHelper, NotificationStoreHelper } from '../../mixins';
import { TrackingService } from '../../api';
import { CompletePoint, Geofence, GeofenceAdd, Point, PointsOfInterest, Polygon, PolygonComplete } from '../../models';
import { isProductionMode, ElementId, hasElements, GeofenceElement } from '../../utils';
import Input from "../Input.vue"
import { geofencePatchError, geofenceReprocessMsg, geofenceSuccessPatchMsg, getGeofenceAlertForEdition } from '../../../tracking/utils';
@Component({
    components:{
        Input,
        DeleteConfirmation
    }
})
export default class AddGeoFence extends Mixins(CompanyStoreHelper, NotificationStoreHelper) {
    @Prop({ default: false }) visible: boolean;
    @Prop({ default: false }) edit: boolean;
    @Prop() positionX: number;
    @Prop() positionY: number;
    @Prop() editDescription: string;
    @Prop() geoFenceId: string | number;
    @Prop() geoFenceToEdit: Geofence | null;
    @Prop() polygons: google.maps.Polygon[];
    @Prop() geoFenceIDS: GeofenceElement[];
    @Prop() geofencesChoices: any;
    @Prop({default: false}) polygonsAreValid: boolean;
    minRules = [v => !!v || 'valor requerido'];
    validCondition: boolean = false;
    loading: boolean = false;
    geofenceSelected: number = 9999;
    previousGeofence: Geofence | null;
    description: string = '';
    alertPatchGeofenceBodyMsg: string = '';
    alertGeofenceConfirmation: boolean = false;

    get canSubmit(){
        if(!this.validCondition){
            return false
        }
        if(this.noElements){
            return false
        }
        if(!this.polygonsAreCorrect){
            return false
        }
        return true
    }

    get polygonsAreCorrect(){
        return this.polygonsAreValid
        
    }

    get tooltipSaveBtn(){
        if(this.description === ''){
            return 'No ingresó el nombre'
        }
        if(this.noElements){
            return 'La geocerca no tiene polígonos'
        }

        if(!this.polygonsAreCorrect){
            return 'Cada polígono debe tener al menos 3 vértices'
        }
        return ''
    }

    @Watch('geoFenceToEdit')
    watchGeofenceEdit(geofence) {
        if (geofence) {
            this.previousGeofence = this.geoFenceToEdit;
            this.$emit('change-geofence-position', 'top', this.geoFenceToEdit);
        }
    }

    updateDescription(value){
        this.description = value;
    }

    handleSubmit(): void {
        
        if (this.edit) {
            if(
                this.geoFenceToEdit && this.geoFenceToEdit['reports'] > 0 ||
                this.geoFenceToEdit && this.geoFenceToEdit['alarms'] > 0
            ){
               this.showGeofenceEditAlert(
                this.geoFenceToEdit['reports'],
                this.geoFenceToEdit['alarms']
            ); 
            }else{
                this.editGeo();
            }
        } else {
            this.save();
        }
    }
    get noElements(): boolean {
        return !hasElements(this.polygons) && !hasElements(this.geoFenceIDS);
    }

    buildGeoFence(polygons: google.maps.Polygon[]): GeofenceAdd {
        let resultPolygons: PolygonComplete[] = [];
        for (let i = 0; i < polygons.length; i++) {
            if (polygons[i].getMap()) {
                let paths: google.maps.MVCArray<google.maps.LatLng> = polygons[i].getPath();
                let points: CompletePoint[] = [];
                paths.forEach(path => {
                    points.push({ latitude: path.lat(), longitude: path.lng() });
                });
                if (points.length) {
                    points.push(points[0]);
                    resultPolygons.push({ points });
                }
            }
        }
        return {
            geofence_type: this.geofenceSelected,
            description: this.description,
            polygons: resultPolygons
        };
    }

    checkValidPolygons(): boolean {
        let valid = true;
        for (let i = 0; i < this.polygons.length; i++) {
            let path: google.maps.MVCArray<google.maps.LatLng> = this.polygons[i].getPath();
            if (path.getLength() < 3 && path.getLength() !== 0) {
                valid = false;
                break;
            }
        }
        return valid;
    }

    save(): void {
        if (this.checkValidPolygons()) {
            this.loading = true;
            TrackingService.postGeoFenceByCompany(this.buildGeoFence(this.polygons), this
                .$_getSelectedCompanyById as string)
                .then(response => {
                    this.loading = false;
                    if (response['status'] === 200 || response['status'] === 204) {
                        if (Array.isArray(response['data'])) {
                            this.addGeoFence(response['data'][0]);
                        } else {
                            this.addGeoFence(response['data']);
                        }
                        this.$_showAddPointOfInterest('Geocerca añadida correctamente');
                    } else {
                        this.$_errorAddPointOfInterest('Problema añadiendo geocerca');
                        this.addGeoFence(null);
                    }
                })
                .catch(error => {
                    this.loading = false;
                     this.$_catchLoadingDialog({
                        response: error.response.data || {},
                        alternative_msg: 'No se pudo agregar la geocerca'
                    });
                    this.addGeoFence(null);
                });
        } else {
            this.$_errorAddPointOfInterest('La geocerca contiene áreas inválidas');
        }
    }

    emitGeofenceSelected(item) {
        this.$emit('geofence-selected', item);
    }

    getPolygonsFromEditGeoFence(): google.maps.Polygon[] {
        let result: google.maps.Polygon[] = [];
        for (let i = 0; i < this.geoFenceIDS.length; i++) {
            if (this.geoFenceIDS[i].id === this.geoFenceId) {
                result = this.geoFenceIDS[i].element as google.maps.Polygon[];
            }
        }
        return result;
    }

    convertToPolygonCompleteToPolygon(complete: PolygonComplete[]): Polygon[] {
        const result: Polygon[] = [];
        for (let i = 0; i < complete.length; i++) {
            result.push({
                points: complete[i].points.map(point => ({ lat: point.latitude, lng: point.longitude }))
            });
        }
        return result;
    }

    showGeofenceEditAlert(totalReports: number, totalAlarms: number){
        /* 
            esta alerta se muestra si la geocerca esta asociada a algun reporte 
        */
        let geofenceAlertMessage = getGeofenceAlertForEdition(totalReports, totalAlarms)
        this.alertPatchGeofenceBodyMsg = geofenceAlertMessage;
        this.alertGeofenceConfirmation = true;
    }

    closeConfirmationGeofenceAlert(userConfirmedPatch: boolean){
        this.alertGeofenceConfirmation = false;
        this.alertPatchGeofenceBodyMsg = '';
        if(userConfirmedPatch){
            this.editGeo();
        }
    }

    editGeo(): void {
        if (this.checkValidPolygons()) {
            this.loading = true;
            const geoFenceEdit: GeofenceAdd = this.buildGeoFence([
                ...this.polygons,
                ...this.getPolygonsFromEditGeoFence()
            ]);
            TrackingService.patchGeofenceByCompany(geoFenceEdit, this.geoFenceId as string)
                .then(response => {
                    this.loading = false;
                    // console.log("patchGeofenceByCompany response", response);
                    if (response['status'] === 200 || response['status'] === 204) {
                        this.editGeoFence({
                            alarms: this.geoFenceToEdit && this.geoFenceToEdit['alarms'] ? this.geoFenceToEdit['alarms'] : 0,
                            reports: this.geoFenceToEdit && this.geoFenceToEdit['reports'] ? this.geoFenceToEdit['reports'] : 0,
                            geofence_type: this.geofenceSelected,
                            geofence_id: this.geoFenceId as string,
                            description: this.description,
                            polygons: this.convertToPolygonCompleteToPolygon(geoFenceEdit.polygons)
                        });
                        this.showAlertReprocessGeofence(response);
                        
                    } else {
                        this.$_errorAddPointOfInterest(geofencePatchError);
                        this.editGeoFence(null);
                    }
                })
                .catch(error => {
                    this.loading = false;
                    this.$_catchLoadingDialog({
                        response: error.response.data || {},
                        alternative_msg: geofencePatchError
                    })
                    this.editGeoFence(null);
                });
        } else {
            this.$_errorAddPointOfInterest('La geocerca contiene áreas inválidas');
        }
    }

    showAlertReprocessGeofence(response){
        let msg = geofenceSuccessPatchMsg;
        // response['data']['reprocess'] = true
        if(response && response['data']['reprocess']){
            msg += ' <br>' + geofenceReprocessMsg
        }  
        this.$_showAddPointOfInterest(msg);
    }

    get form(): HTMLFormElement {
        return this.$refs.form as HTMLFormElement;
    }

    get descriptionInput(): HTMLInputElement {
        return this.$refs.description as HTMLInputElement;
    }

    get geofenceInput(): HTMLInputElement {
        return this.$refs.geofencetype as HTMLInputElement;
    }

    reset() {
        this.form.reset();
    }
    resetValidation() {
        this.form.resetValidation();
    }

    @Emit()
    finalizePolygon() {}

    @Emit()
    cancelGeoFence(geoFence: Geofence | null) {}

    @Emit()
    addGeoFence(geoFence: Geofence | null) {}

    @Emit()
    editGeoFence(geoFence: Geofence | null) {}

    @Emit()
    removeAllPolygons(): void {}

    @Watch('visible')
    observerVisible(newValue: boolean): void {
        if (newValue) {
            this.setFocusAndDescription();
            this.setFocusAndType();
        } else {
            this.$emit('change-geofence-position', 'bottom', this.previousGeofence);
            this.description = '';
            this.geofenceSelected = 9999;
            this.reset();
            this.resetValidation();
        }
    }

    /* @Watch('positionX')
    observerPositionX(): void {
        this.setFocusAndDescription();
        this.resetValidation();
    }
    @Watch('positionY')
    observerPositionY(): void {
        this.setFocusAndDescription();
        this.resetValidation();
    }*/

    setFocusAndDescription(): void {
        let _this = this;
        let geofenceSel = this.geofenceSelected;
        setTimeout(() => this.descriptionInput.focus(), 100);
        if (this.edit) {
            if (this.geoFenceToEdit) {
                this.description = this.editDescription;
            }
        }
    }

    setFocusAndType(): void {
        let _this = this;
        let geofenceSel = this.geofenceSelected;
        setTimeout(() => this.geofenceInput.focus(), 100);
        if (this.edit) {
            if (this.geoFenceToEdit) {
                if (this.geoFenceToEdit.geofence_type) {
                    this.geofenceSelected = this.geoFenceToEdit.geofence_type;
                } else {
                    this.geofenceSelected = 9999;
                }
            }
        } else {
            this.geofenceSelected = 9999;
        }
    }
}
